/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Tabs, Typography } from '@neo4j-ndl/react';
import { useState } from 'react';

type TabValues = '0' | '1' | '2';

const Component = () => {
  const [value, setValue] = useState<TabValues>('0');

  return (
    <div>
      <Tabs value={value} onChange={setValue} className="n-mb-token-8">
        <Tabs.Tab id="0">Tab 1</Tabs.Tab>
        <Tabs.Tab id="1">
          Tab 2 <Tabs.Badge>5</Tabs.Badge>
        </Tabs.Tab>
        <Tabs.Tab id="2">Tab 3</Tabs.Tab>
      </Tabs>
      <Tabs.TabPanel value={value} tabId="0">
        <Typography variant="body-medium">Tab 1 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="1">
        <Typography variant="body-medium">Tab 2 content</Typography>
      </Tabs.TabPanel>
      <Tabs.TabPanel value={value} tabId="2">
        <Typography variant="body-medium">Tab 3 content</Typography>
      </Tabs.TabPanel>
    </div>
  );
};

export default Component;
